import React from 'react'
import { NavigationLocation } from '../utilities/enums'
import { NextpageContext } from '../context/nextpage.context'
import { NextPageRoute } from '../interfaces/next-page-route.interface'
import { Link } from 'react-router-dom'
import NextPageService from '../services/nextpage.service'

class GlobalMainNavObject {
  label: string
  navItems: Array<{
    url?: string
    subnavUrl?: string
    megaMenu?: any
    title: string
  }>
}

class GlobalSubNavObject extends GlobalMainNavObject {
  navParentUrl: string
  topLevelPath: string
}

export type IMenuProps = {
  location: NavigationLocation
  navStartUrl?: string
  sideNavTitle?: string
  nextPage?: NextPageService
}

interface IMenuState {
  sideRootUrl: string
  sideRootTitle: string
  routingEnabled: boolean
  routeSiteSpecificNavs: Array<NextPageRoute>
  sideNavRoute: NextPageRoute
  sideNavToggleClick: Function
  topMenuToggleClick: Function

  topMenuPreviousLinkClick: Function
  siteSpecificNavigationLinkClick: Function
  topMenuSubnavLinkClick: Function

  showMenu: boolean
}

let menu: any = null
let globalMainNav: GlobalMainNavObject = new GlobalMainNavObject()
let globalSubNavs: Array<GlobalSubNavObject> = [new GlobalSubNavObject()]
let routes: NextPageRoute[] = []

class Menu extends React.Component<IMenuProps, IMenuState> {
  static contextType = NextpageContext

  constructor(props: IMenuProps) {
    super(props)
    const nextpage: any = this.props.nextPage
    routes = nextpage.options.navigationRoutes

    switch (this.props.location) {
      case NavigationLocation.Global:
        this.setGlobalMainNav()
        nextpage.UI.registerEvent('topMenuClick', () => {})
        menu = this.createGlobalNav()
        break
      case NavigationLocation.SiteSpecific:
        const subNavs = this.createSubNavs()
        menu = (
          <React.Fragment>
            <nav id='site-specific-nav'>
              <ul>{subNavs}</ul>
            </nav>
          </React.Fragment>
        )
        break
      case NavigationLocation.Side:
        const sideNavs = this.createSideNavs(nextpage)
        let title = ''
        for (let route of routes) {
          if (route.url === this.props.navStartUrl) {
            title = route.title
          }
        }
        menu = (
          <React.Fragment>
            <nav id='left-nav' data-start-url={this.props.navStartUrl} className='row'>
              <div className='col'>
                {this.props.sideNavTitle ? (
                  <h4>{this.props.sideNavTitle}</h4>
                ) : (
                  <h4>{title}</h4>
                )}
                <ul>{sideNavs}</ul>
              </div>
            </nav>
          </React.Fragment>
        )
        break
    }
  }

  componentDidMount() {
    const nextpage = this.context
    switch (this.props.location) {
      case NavigationLocation.Global:
        nextpage.UI.components.globalTopMenu()
        break
      case NavigationLocation.SiteSpecific:
        const mains = document.querySelectorAll('main.container')
        if (mains.length != 0) {
          nextpage.UI.components.layoutMorphs(nextpage.properties)
          nextpage.UI.layout.layoutMorphs(nextpage.properties)
        }
        break
      case NavigationLocation.Side:
        break
    }

    const mainContainer = document.querySelectorAll('main.container')
    if (mainContainer.length != 0) {
      nextpage.UI.components.layoutMorphs(nextpage.properties)
      nextpage.UI.layout.layoutMorphs(nextpage.properties)
    }
  }

  render() {
    return <React.Fragment>{menu}</React.Fragment>
  }

  private createGlobalNav() {
    return (
      <React.Fragment>
        <div id='toggle-menu' className='topmenu' role='button' aria-label='Toggle top menu navigation' aria-pressed='false'>
          <span className='icon-menu-hamburger'>
            <em>menu</em>
          </span>
          <span className='icon-remove'></span>
        </div>
        <div className='headernav' id='top-menu'  onClick={(e) => {e.nativeEvent.stopImmediatePropagation()}}>
          <div id='nav-container'>
            <nav className='mainnav' aria-hidden='false'>
              <ul>
                {globalMainNav.navItems.map((navItem, i) => (
                  <React.Fragment key={i}>
                    {!navItem.subnavUrl && (
                      <li>
                        <Link to={navItem.url!}>{navItem.title}</Link>
                      </li>
                    )}
                    {!navItem.url && (
                      <li data-subnav={navItem.subnavUrl}>
                        {navItem.title}
                      </li>
                    )}
                  </React.Fragment>
                ))}
              </ul>
            </nav>
            <React.Fragment>
              {globalSubNavs.map((subnav, i) => (
                <React.Fragment key={i}>
                  <nav className='subnav aria-hidden' data-nav-parent={subnav.navParentUrl} data-nav-top-level={subnav.topLevelPath} aria-hidden={true}>
                    <ul>
                      <li className='previous'>previous menu</li>
                      {subnav.topLevelPath !== subnav.navParentUrl && (
                        <li className='parent-link'>
                          <Link
                            to={`/${subnav.topLevelPath}/${subnav.navParentUrl}`}
                          >
                            {subnav.label}
                          </Link>
                        </li>
                      )}
                      {subnav.topLevelPath === subnav.navParentUrl && (
                        <li className='parent-link'>
                          <Link to={`/${subnav.navParentUrl}`}>
                            {subnav.label}
                          </Link>
                        </li>
                      )}
                      {subnav.navItems.map((subnavItem, j) => (
                        <React.Fragment key={j}>
                          {!subnavItem.subnavUrl && (
                            <li>
                              <Link to={`${subnavItem.url}`}>
                                {subnavItem.title}
                              </Link>
                            </li>
                          )}
                          {!subnavItem.url && (
                            <li data-subnav={subnavItem.subnavUrl}>
                              {subnavItem.title}
                            </li>
                          )}
                        </React.Fragment>
                      ))}
                    </ul>
                  </nav>
                </React.Fragment>
              ))}
            </React.Fragment>
          </div>
          <hr className='separator'></hr>
          <h3>quick links</h3>
          <ul>
            <li>
              <a href='https://inside.chevron.com'>inside home</a>
            </li>
            <li>
              <a href='https://identitymgmt.chevron.net/Users/Search'>
                people finder
              </a>
            </li>
            <li>
              <a href='https://chevron.sharepoint.com/sites/enterprisewiki/Pages/Landing.aspx'>
                chevronpedia
              </a>
            </li>
          </ul>
          <hr className='separator'></hr>
          <ul>
            <li>
              <a href='https://www.timeanddate.com/worldclock/' target='_blank' rel='noopener'>
                world clock
              </a>
            </li>
            <li>
              <a href='https://www.wunderground.com/' target='_blank' rel='noopener'>
                weather
              </a>
            </li>
            <li>
              <a href='https://www.chevron.com/' target='_blank' rel='noopener'>
                chevron.com
              </a>
            </li>
          </ul>
        </div>
      </React.Fragment>
    )
  }

  private createSubNavs() {
    return routes.map((route, i) => (
      <React.Fragment key={i}>
        <li key={route.title}>
          <Link to={`/${route.url}`}>{route.title}</Link>
          {route.megaMenu && (
            <div className='mega-menu'>
              <div className='row'>
                {route.children?.map((child, j) => (
                  <React.Fragment key={j}>
                    <div className={`col-` + route.megaMenu?.columnSize}>
                      <Link
                        key={child.title}
                        to={`/${route.url}/${child.url}`}
                      >
                        <h3>{child.title}</h3>
                      </Link>
                      <ul className='in-mega'>
                        {child.children?.map((grandChild, k) => (
                          <li key={k}>
                            <Link
                              key={grandChild.title}
                              to={`/${route.url}/${child.url}/${grandChild.url}`}
                            >
                              {grandChild.title}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </React.Fragment>
                ))}
              </div>
            </div>
          )}
          {route.children?.length! > 0 && !route.megaMenu && (
            <ul>
              {route.children?.map((child, j) => (
                <React.Fragment key={j}>
                  <li key={child.title}>
                    <Link to={`/${route.url}/${child.url}`}>
                      {child.title}
                    </Link>
                  </li>
                </React.Fragment>
              ))}
            </ul>
          )}
        </li>
      </React.Fragment>
    ))
  }

  private createSideNavs(nextpage: any) {
    return routes.map((route, i) => (
      <React.Fragment key={i}>
        {this.props.navStartUrl && route.url === this.props.navStartUrl && (
          <li key={route.title} id='route-nav' className={`${route.children ? 'children' : ''}`}>
            {route.children && (
              <span className='nav-toggle' onClick={nextpage.UI.events.detailPageNavigationToggleClick}></span>
            )}
            <Link to={route.url}>{route.title}</Link>
            {route.children && (
              <ul>
                <React.Fragment>
                  {this.mapSideNavRouteChildren(route)}
                </React.Fragment>
              </ul>
            )}
          </li>
        )}
        {!this.props.navStartUrl && (
          <li key={route.title} id='route-nav' className={`${route.children ? 'children' : ''}`}>
            {route.children && (
              <span className='nav-toggle' onClick={nextpage.UI.events.detailPageNavigationToggleClick}></span>
            )}
            <Link to={`/${route.url}`}>{route.title}</Link>
            {route.children && (
              <ul>
                <React.Fragment>
                  {this.mapSideNavRouteChildren(route)}
                </React.Fragment>
              </ul>
            )}
          </li>
        )}
      </React.Fragment>
    ))
  }

  private mapSideNavRouteChildren(route: NextPageRoute) {
    return route.children?.map((child, j) => (
      <React.Fragment key={j}>
        <li key={child.title}>
          <Link to={`/${route.url}/${child.url}`}>
            {child.title}
          </Link>
        </li>
      </React.Fragment>
    ))
  }

  private setGlobalMainNav() {
    const nextpage = this.props.nextPage!
    const topNav = new GlobalMainNavObject()
    let subNavList = new Array<GlobalSubNavObject>()
    topNav.label = nextpage.options.sitename
    topNav.navItems = []
    for (const menuItem of nextpage.options.navigationRoutes) {
      if (menuItem.url.length === 0 || menuItem.title === undefined) {
        continue
      }
      if (menuItem.children === undefined || menuItem.children.length === 0) {
        topNav.navItems.push({
          title: menuItem.title,
          url: menuItem.url,
          megaMenu: menuItem.megaMenu || null
        })
        continue
      }
      topNav.navItems.push({
        title: menuItem.title,
        subnavUrl: menuItem.url
      })
      const newSubNavs = this.getSubNavs(
        menuItem.url,
        menuItem.title,
        menuItem.children,
        menuItem.url
      )
      subNavList = subNavList.concat(newSubNavs)
    }

    globalMainNav = topNav
    globalSubNavs = subNavList
  }

  private getSubNavs(
    parentUrl: string,
    parentLabel: string,
    menuChildren: NextPageRoute[],
    topLevelPath: string
  ) {
    const newSubNav = new GlobalSubNavObject()
    let subNavList = new Array<GlobalSubNavObject>()
    newSubNav.label = parentLabel
    newSubNav.navParentUrl = parentUrl
    newSubNav.topLevelPath = topLevelPath
    newSubNav.navItems = []
    this.setSubNavChildren(parentUrl, menuChildren, topLevelPath, newSubNav, subNavList)
    
    return subNavList.length === 0
      ? [newSubNav]
      : [newSubNav].concat(subNavList)
  }

  private setSubNavChildren(
    parentUrl: string,
    menuChildren: NextPageRoute[],
    topLevelPath: string,
    newSubNav: GlobalSubNavObject,
    subNavList: Array<GlobalSubNavObject>) {
    for (const menuItem of menuChildren) {
      if (menuItem.url.length === 0 || menuItem.title === undefined) {
        continue
      }
      if (menuItem) {
        if (menuItem.children === undefined || menuItem.children.length === 0) {
          this.addMenuChildrenToSubNav(topLevelPath, parentUrl, newSubNav, menuItem)
          continue
        }
        newSubNav.navItems.push({
          title: menuItem.title,
          subnavUrl: menuItem.url
        })
        subNavList = subNavList.concat(this.getSubNavs(
          menuItem.url,
          menuItem.title,
          menuItem.children,
          topLevelPath
        ))
      }
    }
  }

  private addMenuChildrenToSubNav(topLevelPath: string, parentUrl: string, newSubNav: GlobalSubNavObject, menuItem: NextPageRoute) {
    if (topLevelPath === parentUrl) {
      newSubNav.navItems.push({
        title: menuItem.title,
        url: ''.concat('/', parentUrl, '/', menuItem.url),
        megaMenu: menuItem.megaMenu || null
      })
    } else {
      newSubNav.navItems.push({
        title: menuItem.title,
        url: ''.concat(
          '/',
          topLevelPath,
          '/',
          parentUrl,
          '/',
          menuItem.url
        ),
        megaMenu: menuItem.megaMenu || null
      })
    }
  }

}


export default Menu
